var React = require('react');

function FreeCharging (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 0C10.7495 0 0 10.7495 0 24C0 37.2505 10.7495 48 24 48C37.2505 48 48 37.2505 48 24C48 10.7495 37.2505 0 24 0ZM24 43.1904C13.4188 43.1904 4.80962 34.5812 4.80962 24C4.80962 13.4188 13.4188 4.80962 24 4.80962C34.5812 4.80962 43.1904 13.4188 43.1904 24C43.1904 34.5812 34.5812 43.1904 24 43.1904ZM25.8036 7.16633L14.982 27.6072H22.5331V40.8337L33.018 20.3928H25.8036V7.16633Z","fill":"black"}));
}

FreeCharging.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = FreeCharging;

FreeCharging.default = FreeCharging;
